module.exports = __webpack_public_path__ + "img/seats.5212fabb.jpg";